import { Validator } from '@vista-digital/validator';
export const ticketRedemptionCodeFormatValidator = Validator.object({
    partialFormat: Validator.nonEmptyString,
    fullFormat: Validator.nonEmptyString,
    prefixLength: Validator.number({ min: 0 })
});
//# sourceMappingURL=ticket-redemption-code-format.js.map